import { render, staticRenderFns } from "./AllForecast.vue?vue&type=template&id=23fe2d06"
import script from "./AllForecast.vue?vue&type=script&lang=ts"
export * from "./AllForecast.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports